<template>
  <div class="modal-overlay">
    <transition name="fade">
      <div v-if="showSuccessMessage" class="success-message-overlay">
        <div class="success-message-card">
          <div class="success-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h3 class="success-title">{{ responseMessage }}</h3>
        </div>
      </div>
    </transition>

    <div class="modal-wrapper" @click.stop>
      <!-- <div ref="ticketCard" class="ticket-card" id="ticket-to-print">
        <div class="ticket-header">
          <h2 class="ticket-title">
            {{ ticketData ? ticketData.event_management.event_title : '' }}
            Ticket
          </h2>
        </div>

        <div class="ticket-content">
          <div class="ticket-row highlight">
            <span class="label"
              >Registration No<span class="colon">:</span></span
            >
            <span class="value reg-no">{{
              ticketData ? ticketData.registration_no : ''
            }}</span>
          </div>

          <div class="ticket-divider"></div>

          <div class="ticket-row">
            <span class="label">Name<span class="colon">:</span></span>
            <span class="value">{{ ticketData ? ticketData.name : '' }}</span>
          </div>

          <div class="ticket-row">
            <span class="label">Sex<span class="colon">:</span></span>
            <span class="value">{{ ticketData ? ticketData.sex : '' }}</span>
          </div>

          <div class="ticket-row">
            <span class="label">Phone<span class="colon">:</span></span>
            <span class="value">{{ ticketData ? ticketData.phone : '' }}</span>
          </div>

          <div class="ticket-row">
            <span class="label">Occupation<span class="colon">:</span></span>
            <span class="value">{{
              ticketData ? ticketData.occupation : ''
            }}</span>
          </div>

          <div class="ticket-divider"></div>

          <div class="ticket-row">
            <span class="label"
              >Registration Date<span class="colon">:</span></span
            >
            <span class="value">{{
              formatDateValue(ticketData ? ticketData.created_date : '')
            }}</span>
          </div>
        </div>

        <div class="ticket-footer">
          <p class="ticket-note">Please present this ticket at the event</p>
        </div>
      </div> -->

      <img
        :src="urlImage"
        class="rounded-lg shadow-lg mb-3"
        style="max-width: 100%; max-height: 80vh; width: auto; height: auto;"
      />

      <div class="modal-actions no-print">
        <button
          class="btn-download"
          @click.prevent="downloadTicket(urlImage)"
          :disabled="isDownloading"
        >
          <span v-if="!isDownloading">Download Ticket</span>
          <span v-else>
            <i class="fa fa-spinner fa-spin"></i> Downloading...
          </span>
        </button>
      </div>

      <div class="attachments-section no-print">
        <div class="attachments-header">
          <h3 class="attachments-title">Event Attach File</h3>
          <span
            v-if="attachments && attachments.length"
            class="attachments-count"
          >
            {{ attachments.length }} file(s)
          </span>
        </div>

        <div
          class="drive-wrapper drive-list-view"
          v-if="attachments && attachments.length > 0"
        >
          <div
            class="list-items-wrapper ts-overflow-y-auto ts-overflow-x-hidden"
            style="max-height: 400px; padding: 0;"
          >
            <div
              class="drive-item drive-item-row"
              v-for="(entry, index) in attachments"
              :key="index"
            >
              <div class="list-row ts-cursor-pointer">
                <div
                  class="drive-item-thumb drive-item-list-thumb"
                  @dblclick="onOpen(entry)"
                >
                  <file-icon-thumbnail
                    :entry="entry"
                    :icon-size="iconSize"
                    class="pr-2"
                  />
                </div>

                <div
                  class="drive-item-title drive-item-list-title"
                  @dblclick="onOpen(entry)"
                >
                  {{ entry.data.attributes.name }}
                </div>

                <div class="drive-item-actions">
                  <a @click.prevent="download(entry)" v-tooltip="'Download'">
                    <i class="fa fa-download fa-lg"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-attachments">
          <svg
            class="empty-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
            ></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <p>No attachments uploaded</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import FileIconThumbnail from './FileIconThumbnail'
import * as FileDownload from 'downloadjs'
export default {
  name: 'RegisteredForm',
  components: {
    FileIconThumbnail
  },
  props: {
    ticketData: {
      type: Object,
      default: null
    },
    responseMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      model: {
        name: '',
        sex: '',
        phone: '',
        email: '',
        occupation: '',
        otherOccupation: '',
        event_mgt_id: null
      },
      iconSize: 'fa-3x',
      showSuccessMessage: false,
      isDownloading: false,
      urlImage: ''
    }
  },
  mounted() {
    this.previewTicket()
    // Show success message when component mounts
    if (this.responseMessage) {
      this.showSuccessMessage = true

      // Hide after 2 seconds
      setTimeout(() => {
        this.showSuccessMessage = false
      }, 2000)
    }
  },
  computed: {
    attachments() {
      if (!this.ticketData || !this.ticketData.attachments) {
        return []
      }

      return this.ticketData.attachments.map(attachment => {
        const fileType = this.getFileType(attachment.attach_file_name)
        const mimetype = this.getMimeType(attachment.attach_file_name)

        return {
          data: {
            id: attachment.event_att_id,
            type: fileType,
            attributes: {
              name: attachment.attach_file_name,
              file_url: attachment.storage_path,
              mimetype: mimetype,
              created_at: this.ticketData.created_date,
              updated_at: this.ticketData.created_date
            }
          }
        }
      })
    }
  },
  methods: {
    previewTicket() {
      console.log(this.ticketData)
      this.loading = true
      this.$store
        .dispatch('eventManagement/generateTicket', {
          registration_id: this.ticketData.registration_id
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.loading = false
          this.urlImage = response.url_images
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = true
        })
    },

    // async downloadTicket(showSuccess = true) {
    //   this.isDownloading = true
    //   const ticketElement = this.$refs.ticketCard

    //   if (!ticketElement) {
    //     if (showSuccess)
    //       this.$toasted.error('Error: Could not find ticket element.')
    //     this.isDownloading = false
    //     return
    //   }

    //   try {
    //     // Use html2canvas to capture the element
    //     const canvas = await html2canvas(ticketElement, {
    //       useCORS: true,
    //       scale: 2,
    //       logging: false,
    //       allowTaint: true,
    //       imageTimeout: 0,
    //       removeContainer: false,
    //       width: ticketElement.offsetWidth,
    //       height: ticketElement.offsetHeight,
    //       backgroundColor: '#ffffff'
    //     })

    //     // Convert canvas to data URL
    //     const screenshotUrl = canvas.toDataURL('image/png')

    //     // Create a link to download the screenshot
    //     const link = document.createElement('a')
    //     const regNo = this.ticketData
    //       ? this.ticketData.registration_no
    //       : 'ticket'
    //     link.download = `${regNo}_Event_Ticket.png`
    //     link.href = screenshotUrl
    //     link.click()
    //   } catch (error) {
    //     console.error('Error capturing screenshot:', error)
    //   } finally {
    //     // Delay setting isDownloading to false slightly for visual feedback
    //     setTimeout(() => {
    //       this.isDownloading = false
    //     }, 500)
    //   }
    // },

    download(entry, showSuccess = true) {
      FileDownload(entry.data.attributes.file_url)

      if (showSuccess) {
        this.$toasted.info(`Downloading ${entry.data.attributes.name}...`)
      }
    },
    downloadTicket(url) {
      if (!url) return

      this.isDownloading = true // Start loading state

      // Use setTimeout to simulate async download if FileDownload is synchronous
      try {
        FileDownload(url)

        // Optional: show toast or success message
        this.$toasted.success('Ticket download started!')
      } catch (error) {
        this.$toasted.error('Error downloading ticket.')
      } finally {
        // Delay resetting isDownloading for a short visual feedback
        setTimeout(() => {
          this.isDownloading = false
        }, 500)
      }
    },
    clearData() {
      this.model = {
        name: '',
        sex: '',
        phone: '',
        email: '',
        occupation: '',
        otherOccupation: '',
        event_mgt_id: null
      }
    },
    async onOpen(entry) {
      const data = entry.data

      if (data.type === 'image') {
        window.open(data.attributes.file_url, '_blank')
      } else if (data.attributes.mimetype === 'pdf') {
        window.open(data.attributes.file_url, '_blank')
      } else {
        FileDownload(data.attributes.file_url, data.attributes.name)
      }
    },
    getFileType(filename) {
      const ext = filename
        .toLowerCase()
        .split('.')
        .pop()

      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)) {
        return 'image'
      }

      if (ext === 'pdf') {
        return 'file'
      }

      return 'file'
    },
    getMimeType(filename) {
      const ext = filename
        .toLowerCase()
        .split('.')
        .pop()

      const mimeTypes = {
        jpg: 'jpeg',
        jpeg: 'jpeg',
        png: 'png',
        gif: 'gif',
        bmp: 'bmp',
        webp: 'webp',
        svg: 'svg+xml',
        pdf: 'pdf'
      }

      return mimeTypes[ext] || 'octet-stream'
    }
  }
}
</script>

<style scoped>
/* ... (Success Message Styles, Modal Styles, Ticket Styles, Button Styles remain unchanged) ... */
.success-message-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
  backdrop-filter: blur(4px);
}

.success-message-card {
  background: white;
  padding: 40px 50px;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 90%;
  animation: scaleIn 0.3s ease;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #d5905d 0%, #b67c4b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: checkmark 0.5s ease 0.2s both;
}

@keyframes checkmark {
  0% {
    transform: scale(0) rotate(-45deg);
  }
  50% {
    transform: scale(1.2) rotate(10deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}

.success-icon svg {
  width: 45px;
  height: 45px;
  color: white;
  stroke-width: 3;
}

.success-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
  overflow-y: auto;
  background: white;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-wrapper {
  position: relative;
  max-width: 650px;
  width: 100%;
  animation: slideUp 0.3s ease;
  margin: auto;
  z-index: 10001;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ticket Styles */
.ticket-card {
  background: white;
  border: 3px solid #d5905d;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.ticket-header {
  background: #d5905d;
  padding: 25px;
  text-align: center;
}

.ticket-title {
  color: white;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.ticket-content {
  padding: 25px;
  position: relative;
  z-index: 1;
  background-color: transparent;
}

.ticket-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/assets/images/logo-bti.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100%;
  opacity: 0.15;
  z-index: -1;
}

.ticket-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
}

.ticket-row.highlight {
  background: #fff8f0;
  padding: 14px;
  border-radius: 8px;
  margin-bottom: 18px;
  border-left: 4px solid #d5905d;
  border-right: 4px solid #d5905d;
}

.ticket-row .label {
  font-size: 0.95rem;
  font-weight: 600;
  color: #666;
  flex-basis: 40%;
  min-width: 40%;
  text-align: left;
  display: inline-block;
}

.ticket-row .label .colon {
  position: absolute;
  left: 50%;
}

.ticket-row .value {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  text-align: right;
  flex-grow: 1;
  min-width: 0;
}

.ticket-row .reg-no {
  color: #d5905d;
  font-size: 1.15rem;
  font-weight: 700;
}

.ticket-divider {
  height: 1px;
  background: #d5905d;
  margin: 18px 0;
}

.ticket-footer {
  background: #f8f9fa;
  padding: 20px;
  text-align: center;
}

.ticket-note {
  font-size: 12px;
  color: #666;
  margin: 0;
  font-style: italic;
}

.modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

/* **** BUTTON STYLES WITH LOADING STATE SUPPORT **** */
.btn-download {
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #d5905d 0%, #b67c4b 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(213, 144, 93, 0.4);
}

.btn-download:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(213, 144, 93, 0.5);
}

/* Disabled/Loading State */
.btn-download:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #b67c4b; /* Solid color for disabled state */
  transform: none;
  box-shadow: none;
}
/* **** END BUTTON STYLES **** */

/* Attachments Section */
.attachments-section {
  background: white;
  border: 3px solid #d5905d;
  border-radius: 12px;
  margin-top: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.attachments-header {
  background: #d5905d;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d5905d;
}

.attachments-title {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.attachments-count {
  background: #d5905d;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

/* Drive Wrapper */
.drive-wrapper {
  padding: 15px;
  background: white;
}

/* ------------------------------------------------------------------ */
/* ***** DRIVE LIST VIEW STYLES (One-Item-Per-Row, EQUALIZED WIDTHS) ***** */
/* ------------------------------------------------------------------ */

/* Fix: Ensure the container of rows is not a flex/grid container itself */
.list-items-wrapper {
  display: block !important;
}

/* Individual item/row container */
.drive-item-row {
  display: block;
  width: 100%;
  background: white;
  border: none;
  border-bottom: 1px solid #e0e0e0; /* Separator line between files */
  border-radius: 0;
  overflow: visible;
  transition: background-color 0.2s;
}

.drive-item-row:last-child {
  border-bottom: none;
}

.drive-item-row:hover {
  background-color: #f5f5f5;
  box-shadow: none;
  transform: none;
}

/* The core Flexbox row: Thumbnail | Name | Button */
.list-row {
  display: flex;
  align-items: center; /* Vertically center all items in the row */
  gap: 10px; /* Space between the thumbnail, name, and actions */
  padding: 8px 0;
}

/* 1. Thumbnail: Set to a small fixed size and 15% basis */
.drive-item-thumb.drive-item-list-thumb {
  flex-shrink: 0;
  flex-basis: 15%; /* Takes about 15% of the row width */
  max-width: 15%;
  width: 30px; /* Smaller fixed size */
  height: 30px; /* Smaller fixed size */
  display: flex;
  justify-content: flex-start; /* Align thumbnail to the left of its column */
  align-items: center;
  margin-bottom: 0;
  /* Adjust padding to ensure spacing is even */
  padding-left: 0;
  padding-right: 0;
}

/* 2. Name: Set to 70% basis (the majority of the width) */
.drive-item-list-title {
  flex-grow: 1;
  flex-basis: 70%; /* Takes about 70% of the row width */
  min-width: 0; /* Allows text to truncate */
  text-align: left;
  margin-top: 0;
  min-height: auto;
  padding-right: 10px;

  color: #333;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: none;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
}

/* 3. Download Button/Actions: Set to 15% basis and aligned right */
.drive-item-actions {
  flex-shrink: 0;
  flex-basis: 15%; /* Takes about 15% of the row width */
  max-width: 15%;
  display: flex;
  justify-content: flex-end; /* Push button to the far right */
  align-items: center;
  padding: 5px 0;
}

.drive-item-actions a {
  display: inline-block;
  padding: 5px;
  color: #d5905d;
  transition: color 0.2s ease;
}

.drive-item-actions a:hover {
  color: #b67c4b;
}

.drive-item-actions a i {
  /* Button size */
  font-size: 24px !important;
  vertical-align: middle;
}

/* Empty State */
.no-attachments {
  padding: 40px 20px;
  text-align: center;
  color: #999;
}

.empty-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  color: #ccc;
  stroke-width: 2;
}

.no-attachments p {
  margin: 0;
  font-size: 14px;
}

/* Utility Classes */
.ts-overflow-y-auto {
  overflow-y: auto;
}
.ts-overflow-x-hidden {
  overflow-x: hidden;
}
.ts-cursor-pointer {
  cursor: pointer;
}
.ts-opacity-5 {
  opacity: 0.5;
}
.pr-2 {
  padding-right: 0.5rem;
}
.text-center {
  text-align: center;
}

/* ------------------------------------------------------------------ */
/* ***** RESPONSIVE STYLES (Updated for List View) ***** */
/* ------------------------------------------------------------------ */
@media (max-width: 768px) {
  /* ... (Other 768px styles remain unchanged) ... */
}

@media (max-width: 500px) {
  /* ... (Mobile modal/ticket adjustments remain unchanged) ... */

  /* *** LIST VIEW MOBILE ADJUSTMENTS *** */
  .drive-wrapper {
    padding: 10px 15px;
  }

  .list-row {
    gap: 8px;
    padding: 6px 0;
  }

  /* Adjust basis for smaller screen: 20% | 60% | 20% */
  .drive-item-list-thumb {
    flex-basis: 20%;
    max-width: 20%;
    width: 28px; /* Slightly smaller fixed size for mobile */
    height: 28px;
  }

  .drive-item-list-title {
    flex-basis: 60%;
    font-size: 13px;
  }

  .drive-item-actions {
    flex-basis: 20%;
    max-width: 20%;
  }

  .drive-item-actions a i {
    font-size: 20px !important;
  }
  /* *** END LIST VIEW MOBILE ADJUSTMENTS *** */

  /* ... (Rest of the mobile styles remain unchanged) ... */
}

/* Print Styles */
@media print {
  body * {
    visibility: hidden;
  }

  #ticket-to-print,
  #ticket-to-print * {
    visibility: visible;
  }

  #ticket-to-print {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .modal-overlay {
    background: white !important;
    position: static;
  }

  .modal-wrapper {
    box-shadow: none;
    max-width: 100%;
  }

  .no-print,
  .success-message-overlay {
    display: none !important;
  }

  .ticket-card {
    box-shadow: none;
    page-break-inside: avoid;
  }
}
</style>
